/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidSubmissionsControllerUpdateMutationRequest, BidSubmissionsControllerUpdateMutationResponse, BidSubmissionsControllerUpdatePathParams, BidSubmissionsControllerUpdate400, BidSubmissionsControllerUpdate401, BidSubmissionsControllerUpdate403, BidSubmissionsControllerUpdate404 } from "../../models/bidsController/BidSubmissionsControllerUpdate";

function getBidSubmissionsControllerUpdateUrl(id: BidSubmissionsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/bid-submissions/${id}` as const }  
  return res
}

/**
 * @description Waiting (IDENTIFYING or AWAITING_CONFIRM): assigns it. Already assigned: moves it, undoing what its read wrote, and it is read again. kind alone switches it between bid and reply.
 * @summary Confirm who sent a bid, or move it to another trade partner
 * {@link /api/v1/bid-submissions/:id}
 */
export async function bidSubmissionsControllerUpdate(id: BidSubmissionsControllerUpdatePathParams["id"], data?: BidSubmissionsControllerUpdateMutationRequest, config: Partial<RequestConfig<BidSubmissionsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidSubmissionsControllerUpdateMutationResponse, ResponseErrorConfig<BidSubmissionsControllerUpdate400 | BidSubmissionsControllerUpdate401 | BidSubmissionsControllerUpdate403 | BidSubmissionsControllerUpdate404>, BidSubmissionsControllerUpdateMutationRequest>({ method : "PATCH", url : getBidSubmissionsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}